module.exports = __webpack_public_path__ + "static/media/invoice.d29cbc90.svg";